<template>
  <button
    class="button button-round button-100"
    :class="{
      ...colorClass,
      'is-loading': loading,
      'with-icon': withIcon,
      'full-width': fullWidth,
    }"
    :type="type"
    :disabled="disabled || loading"
    :data-testid="dataTestid"
    @click="$emit('click')"
  >
    <slot v-if="!loading" />
  </button>
</template>

<script>
export default {
  name: 'Button',
  emits: ['click'],
  props: {
    type: { type: String, default: 'button' },
    disabled: { type: Boolean, required: false },
    dataTestid: { type: String, required: false },
    color: { type: String, default: 'green' },
    loading: { type: Boolean, default: false },
    withIcon: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
  },
  computed: {
    colorClass() {
      return { [`button-${this.color}`]: true }
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  position: relative;
  margin: 0 auto 0.7rem;
  max-width: 400px;
}
button.is-loading {
  position: relative;
  height: 46px;
}

button.is-loading::after {
  display: block;
  position: absolute;
  top: calc(50% - (1em * 0.5));
  left: calc(50% - (1em * 0.5));
  transform: none;
  margin-top: 0;
  border: 2px solid #fff;
  border-radius: 9999px;
  border-top-color: transparent;
  border-right-color: transparent;
  width: 1em;
  height: 1em;
  animation: spinAround 0.5s infinite linear;
  content: '';
}

button.with-icon {
  display: flex;
  justify-content: center;
  align-items: center;

  .material-icons {
    margin: 0 6px;
  }
}

button.full-width {
  max-width: none !important;
}
</style>
